import api from "@/services/api";

// Studentless "individual documents" chatbot. Lists document types from a
// configured school+year, fetches a blank online template to fill in the
// regular WorkOnline modal (no sockets / no persisted Document), and renders
// the answers to a Word file. See backend DocumentViewSet
// (list_individual_document_types / get_individual_document_template /
// render_individual_document).
export default {
  // {} -> { school_id, document_types: [{id, name}] }
  listDocumentTypes(payload) {
    return api
      .post("list_individual_document_types/", payload || {})
      .then((response) => response.data);
  },
  // { document_type_id } -> { templates: [{template_id, diagnostic, diagnostic_label, name}] }
  listDocumentTemplates(payload) {
    return api
      .post("list_individual_document_templates/", payload)
      .then((response) => response.data);
  },
  // { role } -> { role } — persists the chosen role onto the logged-in user
  // (the role is the same across every individual document).
  setUserRole(payload) {
    return api
      .post("set_individual_user_role/", payload)
      .then((response) => response.data);
  },
  // { template_id, grade } -> { template_id, diagnostic, school_id, document_template, document_type }
  getBlankTemplate(payload) {
    return api
      .post("get_individual_document_template/", payload)
      .then((response) => response.data);
  },
  // { document_name, diagnostic } -> { template_id, document_type_id,
  //   school_id, diagnostic } for a related document (same source school+year).
  resolveRelatedDocument(payload) {
    return api
      .post("resolve_individual_document/", payload)
      .then((response) => response.data);
  },
  // { template_id, document_type_id, school_id, context } -> docx blob.
  // `context` is the already-resolved docxtpl context built on the client by
  // individualDocumentContext.buildRenderContext.
  renderDocument(payload) {
    return api
      .post("render_individual_document/", payload, { responseType: "blob" })
      .then((response) => response);
  },
  // Studentless replacement for documentOnlineService.getPageInfo (paged
  // online templates). { page, template, school, grade, diagnostic } ->
  // { rows, ... } (same shape DocumentTemplatePageSerializer produces).
  getPageInfo(payload) {
    const params = new URLSearchParams(payload).toString();
    return api
      .get(`get_individual_page_info/?${params}`)
      .then((response) => response.data);
  },
};
